import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const MaskedLines = ({ lines = [], as: Tag = "h1", className = "", lineClasses = [], delay = 0, inView = false }) => {
  const ref = useRef(null);
  const visible = useInView(ref, { once: true, margin: "-40px" });
  const revealed = !inView || visible;

  return (
    <Tag ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block ${lineClasses[i] || ""}`}
            initial={{ y: "110%" }}
            animate={revealed ? { y: "0%" } : {}}
            transition={{ duration: 0.9, ease: EASE, delay: delay + i * 0.13 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeUp = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);
